import React from 'react';

import GenericFooterComponent from './GenericFooterComponent';
import BurnFooterComponent from './BurnFooterComponent';
import MaciFooterComponent from './MaciFooterComponent';
// import AxsomeFooterComponent from './AxsomeFooterComponent';

const footerMapping = {
  // axsomeprograms: AxsomeFooterComponent
  vericelburncare: BurnFooterComponent,
  vericelmaci: MaciFooterComponent
};

const renderFooterComponent = (company, tenant, meetingInfo) => {
  const FooterComponent = footerMapping[tenant] ? footerMapping[tenant] : GenericFooterComponent;
  return <FooterComponent company={company} tenant={tenant} meetingInfo={meetingInfo} />;
};

export default renderFooterComponent;
